"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orphanInviteFactory = void 0;
const Factory = require("factory.ts");
exports.orphanInviteFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    email_address: 'orphan@invite.com',
});
